import { POItem } from "../Interfaces/IPurchaseOrder";
import axios from "../utils/axiosConfig";
const { BASE_URL } = require("../utils/urls");
//const API_URL = "https://panaccoapi-453601304730.asia-south1.run.app";

//const API_URL = "http://localhost:8080";

interface GetPOParams {
  poNumber: string;
  orgId: string;
  financialYear: string;
}


export const getNewPoNumber = async (orgId: string,financialYear:string) => {
  try {
    const response = await axios.get(`${BASE_URL}/api/purchaseOrders/getNewPoNumber`, {
      params: { orgId ,financialYear},
    });
    return response.data;
  } catch (error: any) {
    console.error("Error generating PO number:", error);
    throw error.response?.data || { message: "Server error" };
  }
};

export const savePurchaseOrder = async (poData: any, items: any[]) => {
  try {
    const response = await axios.post(`${BASE_URL}/api/purchaseOrders/create`, {
      poData,
      items,
    });
    return response.data;
  } catch (error: any) {
    throw error.response?.data || { message: "Server error" };
  }
};

export const getAllPurchaseOrders = async (orgId: string, vendorId?: string) => {
  try {
    const params: any = { orgId };
    if (vendorId) params.vendorId = vendorId;
    const response = await axios.get(`${BASE_URL}/api/purchaseOrders/list`, {
      params,
    });
    return response.data;
  } catch (error: any) {
    throw error.response?.data || { message: "Server error" };
  }
};


export const getPurchaseOrderById = async ({ poNumber, orgId, financialYear }: GetPOParams) => {
  try {
    const response = await axios.get(`${BASE_URL}/api/purchaseOrders/view`, {
      params: {orgId, financialYear,poNumber },
    });

    if (!response.data?.success) {
      throw new Error(response.data?.message || "Failed to fetch Purchase Order");
    }

    return response.data.purchaseOrder;
  } catch (error: any) {
    console.error("Error fetching PO:", error);
    throw (
      error.response?.data || {
        success: false,
        message: "Unable to fetch Purchase Order. Please try again later.",
      }
    );
  }
};
export const updatePurchaseOrderStatus = async (
  poId: string,
  status: "approved" | "rejected" | "cancelled" | "draft",
  updatedBy: string,
  remarks?: string
) => {
  try {
    const response = await axios.patch(`${BASE_URL}/api/purchaseOrders/status/${poId}`, {
      status,
      updatedBy,
      remarks,
    });
    return response.data;
  } catch (error: any) {
    throw error.response?.data || { message: "Server error" };
  }
};

export const updatePurchaseOrder = async (poId: string, poData: any, items: POItem[]) => {
  try {
    const response = await axios.put(
      `${BASE_URL}/api/purchaseOrders/update/${poId}`,
      {
        poData,
        items
      }
    );
    return response.data;
  } catch (error: any) {
    throw error.response?.data || { message: "Server error" };
  }
};

